import { useRef, useEffect } from 'react'

type ReactEventHandler<E extends React.SyntheticEvent> = (event: E) => void

export function useEventListener<E extends React.SyntheticEvent>(
  eventName: keyof HTMLElementEventMap,
  handler: ReactEventHandler<E>,
  element: HTMLElement | Window | null | undefined = window || global,
) {
  const savedHandler = useRef<ReactEventHandler<E> | null>(null)

  useEffect(() => {
    savedHandler.current = handler
  }, [handler])

  useEffect(() => {
    const currrentHandler = savedHandler.current
    if (!currrentHandler) return undefined
    if (!element || !element.addEventListener) return undefined

    element.addEventListener(
      eventName,
      currrentHandler as unknown as EventListener,
    )

    return () => {
      element.removeEventListener(
        eventName,
        currrentHandler as unknown as EventListener,
      )
    }
  }, [eventName, element])
}
